var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55021 9.14939L14.0252 0.67439C14.2252 0.47439 14.4585 0.37439 14.7252 0.37439C14.9919 0.37439 15.2252 0.47439 15.4252 0.67439C15.6252 0.87439 15.7252 1.11189 15.7252 1.38689C15.7252 1.66189 15.6252 1.89939 15.4252 2.09939L6.25021 11.2994C6.05021 11.4994 5.81687 11.5994 5.55021 11.5994C5.28354 11.5994 5.05021 11.4994 4.85021 11.2994L0.550207 6.99939C0.350207 6.79939 0.254374 6.56189 0.262707 6.28689C0.27104 6.01189 0.375207 5.77439 0.575207 5.57439C0.775207 5.37439 1.01271 5.27439 1.28771 5.27439C1.56271 5.27439 1.80021 5.37439 2.00021 5.57439L5.55021 9.14939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c71931f21254abca914918afd6228201.svg";
export { ForwardRef as ReactComponent };